import React, { useState, useEffect } from 'react'
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Tabs,
  Tab
} from 'react-bootstrap'
import { Radio } from 'antd';
import { ChromePicker } from 'react-color'
import { Card } from '../../components/Card/Card'
import Button from '../../components/CustomButton/CustomButton'
import Loading from '../../components/Loading/Loading'
import ReactQuill from 'react-quill'
import { firebaseDb as db } from '../../firebase'
import ReactTooltip from 'react-tooltip'
import { translate } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faTrash, faCircle, faSquare } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faYoutube, faXing, faLinkedinIn, faTiktok, faXTwitter, faWeixin } from '@fortawesome/free-brands-svg-icons';

// Translation model
import { read } from '../../helpers/translationModel/read'
import { write } from '../../helpers/translationModel/write'

// Redux
import { useSelector } from 'react-redux'
import FileSelector from '../FileStorage/Parts/FileSelector'

const socialIconList = ['facebook', 'instagram', 'xTwitter', 'linkedin', 'youtube', 'tiktok', 'xing', 'weChat']
const socialIconMapping = {
  'xTwitter': faXTwitter,
  'facebook': faFacebookF,
  'instagram': faInstagram,
  'linkedin': faLinkedinIn,
  'youtube': faYoutube,
  'tiktok': faTiktok,
  'xing': faXing,
  'weChat': faWeixin
}

const SocialMediaIcon = (props) => {
  return (
    <FontAwesomeIcon
      icon={props.icon}
      size={props.size}
      mask={props.isRound ? faCircle : faSquare}
      transform="shrink-7"
      color={props.color} />
  )
}

const CalHeaderBottom = props => {
  const {
    activeCompany,
    activeCalendar,
    calendarLang,
    calendarLangPrimary
  } = useSelector(state => state)

  const [loading, setLoading] = useState(true)
  const [type, setType] = useState('hide-and-seek')
  const [modules, setModules] = useState()

  const [showTimer, setShowTimer] = useState(false)
  const [timerDuration, setTimerDuration] = useState(50)

  const [newsletterDisplay, setNewsletterDisplay] = useState(true)
  const [newsletterLinkLabel, setNewsletterLinkLabel] = useState('default')
  const [newsletterLinkUrl, setNewsletterLinkUrl] = useState('default')
  const [newsletterText, setNewsletterText] = useState(
    'Loading, please wait ....'
  )

  const [timerText, setTimerText] = useState(
    'Loading, please wait ....'
  )

  const [reminderDisplay, setReminderDisplay] = useState(true)
  const [reminderLinkLabel, setReminderLinkLabel] = useState('default')
  const [reminderLinkUrl, setReminderLinkUrl] = useState('default')
  const [reminderText, setReminderText] = useState('Loading, please wait ....')
  const [counterText, setCounterText] = useState('Loading, please wait ....')
  const [compareBy, setCompareBy] = useState('accuracy')
  
  const [sponsorDisplay, setSponsorDisplay] = useState(false)
  const [sponsors, setSponsors] = useState({ 0: { logo: '', text: '', linkLabel: '', linkUrl: '', default: true } })
  
  const [socialMediaText, setSocialMediaText] = useState('Loading, please wait ....')
  const [useStockIcons, setUseStockIcons] = useState(false)
  const [socialMediaDisplay, setSocialMediaDisplay] = useState(false)
  const [socialMediaSettings, setSocialMediaSettings] = useState({ color: '#606060', size: '2x', isRound: true })
  const [socialMediaIcons, setSocialMediaIcons] = useState(socialIconList.reduce((acc, item) => {
    acc[item] = {
      label: "",
      url: "",
      icon: ""
    }
    return acc
  }, {}))

  const [activeLimitedClicks, setActiveLimitedClicks] = useState(false)
  const [limitedClicks, setLimitedClicks] = useState(0)
  const [limitPlaysToOne, setLimitPlaysToOne] = useState(false)

  useEffect(() => {
    activeCompany && activeCalendar && calendarLang && loadFromDb()
  }, [activeCompany, activeCalendar, calendarLang])

  const loadFromDb = () => {
    activeCompany &&
      activeCalendar &&
      db
        .doc(
          'companies/' +
          activeCompany +
          '/calendars/' +
          activeCalendar +
          '/settings/grid'
        )
        .get()
        .then(async querySnapshot => {
          let data = querySnapshot.data()

          // Replace data with translations
          data = await read(
            activeCompany,
            activeCalendar,
            calendarLangPrimary,
            calendarLang,
            'settings/grid',
            data
          )

          const modules = {
            toolbar: [
              [{ header: [1, 2, 3, false] }],
              [('bold', 'italic', 'underline', 'strike', 'blockquote')],
              [{ align: [] }],
              [
                { list: 'ordered' },
                { list: 'bullet' },
                { indent: '-1' },
                { indent: '+1' }
              ],
              ['link', 'image'],
              [{ color: Object.values(data.colors) }, { color: [] }],
              ['clean']
            ]
          }

          if (data.newsletter) {
            setNewsletterText(data.newsletter.text)
            setNewsletterDisplay(data.newsletter.display)
            setNewsletterLinkLabel(data.newsletter.linkLabel)
            setNewsletterLinkUrl(data.newsletter.linkUrl)
          }

          if (data.timer) {
            setShowTimer(data.timer.showTimer)
            setTimerDuration(data.timer.timerDuration)
            setTimerText(data.timer.timerText)
            setCompareBy(data.timer.compareBy || 'accuracy')
          }

          if (data.socialMedia) {
            !!data.socialMedia.text && setSocialMediaText(data.socialMedia.text)
            setUseStockIcons(data.socialMedia.useStockIcons === 'true' || data.socialMedia.useStockIcons === true)
            setSocialMediaDisplay(data.socialMedia.display === 'true' || data.socialMedia.display === true)
            !!data.socialMedia.settings && setSocialMediaSettings(data.socialMedia.settings)
            !!data.socialMedia.icons && setSocialMediaIcons(data.socialMedia.icons)
          }

          if (data.limitedClicks) {
            setActiveLimitedClicks(data.limitedClicks.active === 'true' || data.limitedClicks.active === true)
            setLimitedClicks(data.limitedClicks.value || 0)
            setLimitPlaysToOne(data.limitedClicks.limitPlaysToOne === 'true' || data.limitedClicks.limitPlaysToOne === true)
          }

          setReminderText(data.reminder && data.reminder.text)
          setReminderDisplay(data.reminder && data.reminder.display)
          setReminderLinkLabel(data.reminder && data.reminder.linkLabelReminder)
          setReminderLinkUrl(data.reminder && data.reminder.linkUrlReminder)
          setCounterText(data.counterText)
          setType(data.type)
          setModules(modules)
          setLoading(false)
          if (data.sponsors) {
            setSponsorDisplay(data.sponsorDisplay)
            setSponsors(data.sponsors)
          } else {
            setSponsors({ 0: { ...sponsors[0], default: false } })
          }
        })
        .catch(error => {
          console.log('error', error)
          notificationOpen('error', error)
        })
  }

  const notificationOpen = (type, errorMessage = '') => {
    if (type === 'success') {
      props.notificationOpen('tr', 'pe-7s-check', 'success', 'saved')
    } else if (type === 'error') {
      const message = 'not saved! Error: ' + errorMessage
      props.notificationOpen('tr', 'pe-7s-close-circle', 'error', message)
    }
  }

  const handleSubmitCounter = event => {
    event.preventDefault()
    const quillEditor = document.querySelector('#counter .ql-editor').innerHTML

    let udpateContent = {
      counterText: quillEditor,
      limitedClicks:  {
        active: activeLimitedClicks,
        value: limitedClicks,
        limitPlaysToOne: limitPlaysToOne
      }
    }
    activeCalendar &&
      write(
        activeCompany,
        activeCalendar,
        calendarLangPrimary,
        calendarLang,
        'settings/grid',
        udpateContent
      )
        .then(() => {
          db.doc('companies/' + activeCompany + '/calendars/' + activeCalendar)
            .update({ changeToPublish: true })
            .then(res => { })
            .catch(error => {
              console.log(error)
            })
          notificationOpen('success')
        })
        .catch(error => {
          notificationOpen('error', error)
        })
  }

  const handleSubmitTimer = event => {
    event.preventDefault()
    const updateContent = {
      timer: {  
        showTimer: showTimer,
        timerDuration: timerDuration,
        timerText: timerText,
        compareBy
      }
    }

    activeCalendar &&
      write(
        activeCompany,
        activeCalendar,
        calendarLangPrimary,
        calendarLang,
        'settings/grid',
        updateContent
      )
        .then(() => {
          db.doc('companies/' + activeCompany + '/calendars/' + activeCalendar)
            .update({ changeToPublish: true })
            .then(res => { })
            .catch(error => {
              console.log(error)
            })
          notificationOpen('success')
        })
        .catch(error => {
          notificationOpen('error', error)
        })
    
  }

  const handleSubmit = event => {
    event.preventDefault()
    const quillEditor = document.querySelector('#newsletter .ql-editor')
      .innerHTML

    let udpateContent = {
      newsletter: {
        text: quillEditor,
        display: newsletterDisplay === 'true' || newsletterDisplay === true,
        linkLabel: newsletterLinkLabel,
        linkUrl: newsletterLinkUrl
      }
    }

    activeCalendar &&
      write(
        activeCompany,
        activeCalendar,
        calendarLangPrimary,
        calendarLang,
        'settings/grid',
        udpateContent
      )
        .then(() => {
          db.doc('companies/' + activeCompany + '/calendars/' + activeCalendar)
            .update({ changeToPublish: true })
            .catch(error => {
              console.log(error)
            })
          notificationOpen('success')
        })
        .catch(error => {
          notificationOpen('error', error)
        })
  }

  const handleSubmitReminder = event => {
    event.preventDefault()
    const quillEditor = document.querySelector('#reminder .ql-editor').innerHTML

    let udpateContent = {
      reminder: {
        text: quillEditor,
        display: reminderDisplay,
        linkLabelReminder: reminderLinkLabel,
        linkUrlReminder: reminderLinkUrl
      }
    }
    activeCalendar &&
      write(
        activeCompany,
        activeCalendar,
        calendarLangPrimary,
        calendarLang,
        'settings/grid',
        udpateContent
      )
        .then(() => {
          db.doc('companies/' + activeCompany + '/calendars/' + activeCalendar)
            .update({ changeToPublish: true })
            .catch(error => {
              console.log(error)
            })
          notificationOpen('success')
        })
        .catch(error => {
          notificationOpen('error', error)
        })
  }

  const handleSubmitSocialMedia = event => {
    event.preventDefault()
    const quillEditor = document.querySelector('#socialMedia .ql-editor') ? document.querySelector('#socialMedia .ql-editor').innerHTML : '';
    
    let udpateContent = {
      socialMedia: {
        text: quillEditor,
        display: socialMediaDisplay,
        settings: socialMediaSettings,
        useStockIcons: useStockIcons,
        icons: socialMediaIcons
      }
    }

    activeCalendar &&
      write(
        activeCompany,
        activeCalendar,
        calendarLangPrimary,
        calendarLang,
        'settings/grid',
        udpateContent
      ).then(() => {
        db.doc('companies/' + activeCompany + '/calendars/' + activeCalendar)
          .update({ changeToPublish: true })
          .catch(error => {
            console.log(error)
          })
        notificationOpen('success')
      })
      .catch(error => {
        notificationOpen('error', error)
      })
  }

  const handleSubmitSponsors = event => {
    event.preventDefault()

    let updateContent = {
      sponsors: { ...sponsors },
      sponsorDisplay
    }
    activeCalendar &&
      write(
        activeCompany,
        activeCalendar,
        calendarLangPrimary,
        calendarLang,
        'settings/grid',
        updateContent
      )
        .then(() => {
          db.doc('companies/' + activeCompany + '/calendars/' + activeCalendar)
            .update({ changeToPublish: true })
            .catch(error => {
              console.log(error)
            })
          notificationOpen('success')
        })
        .catch(error => {
          notificationOpen('error', error)
        })
  }

  const handleChangeQuillCounter = (e) => { setCounterText(e) }
  const handleChangeQuillNewsletter = (e) => { setNewsletterText(e) }
  const handleChangeQuillTimer = (e) => { setTimerText(e) }
  const handleChangeQuillReminder = (e) => { setReminderText(e) }
  const handleChangeQuillSponsor = (e, index) => { !sponsors[index].default && setSponsors({ ...sponsors, [index]: { ...sponsors[index], text: e } }) }
  const handleChangeQuillSocialMedia = (e) => { setSocialMediaText(e) }
  const { t } = props

  return (
    <>
      <Row
        className='show-grid'
        float='center'
        style={loading ? { display: 'block' } : { display: 'none' }}
      >
        <Col xs={12} xsOffset={6} valign='middle'>
          <Loading type='spin' color='green' />
        </Col>
      </Row>

      <Grid
        fluid
        style={!loading ? { visibility: 'visible' } : { visibility: 'hidden' }}
      >
        <Row>
          {['hide-and-seek', 'memory-game'].includes(type) && (
            <Col md={6}>
              <Card
                title={t('calCounterAndNewsletter.counter')}
                content={
                  <>
                    <form onSubmit={handleSubmitCounter}>
                      <FormGroup>
                        <i
                          className='pe-7s-help1 text-success'
                          data-tip={t('counterAndNewsletter.counterText')}
                          style={{
                            position: 'relative',
                            top: '1px',
                            padding: '5px 5px 0 0',
                            fontSize: '15px'
                          }}
                        />
                        <ControlLabel>
                          {t('calCounterAndNewsletter.textOfCounter')}
                        </ControlLabel>
                        <ReactQuill
                          value={counterText}
                          modules={modules}
                          id='counter'
                          name='content'
                          onChange={handleChangeQuillCounter}
                        />
                      </FormGroup>

                      {type === 'hide-and-seek' && <Row>
                        <Col md={12}>
                          <FormGroup>
                            <ControlLabel>
                              <div className='checkbox'>
                                <input
                                  type='checkbox'
                                  id='activeLimitedClicks'
                                  name='activeLimitedClicks'
                                  checked={activeLimitedClicks}
                                  onChange={e =>
                                    setActiveLimitedClicks(e.target.checked)
                                  }
                                />
                                <label htmlFor='activeLimitedClicks'>
                                  {t('calCounterAndNewsletter.activeLimitedClicks')}
                                </label>
                              </div>
                            </ControlLabel>
                            <i
                              className='pe-7s-help1 text-success'
                              data-tip={t('counterAndNewsletter.activeLimitedClicksTip')}
                              style={{
                                position: 'relative',
                                top: '1px',
                                padding: '5px 0 0 5px',
                                fontSize: '15px'
                              }}
                            />
                          </FormGroup>
                          {activeLimitedClicks && 
                            <>
                              <FormGroup>
                                <ControlLabel>
                                  {t('calCounterAndNewsletter.limitedClicks')}
                                </ControlLabel>
                                <FormControl
                                  type='number'
                                  name='timerDuration'
                                  value={limitedClicks}
                                  onChange={e => e.target.value ? setLimitedClicks(parseInt(e.target.value)) : setLimitedClicks(0)}
                                  id='limitedClicks'
                                  min="1"
                                />
                              </FormGroup>
                              <FormGroup>
                                <ControlLabel>
                                  <div className='checkbox'>
                                    <input
                                      type='checkbox'
                                      id='limitPlaysToOne'
                                      name='limitPlaysToOne'
                                      checked={limitPlaysToOne}
                                      onChange={e =>
                                        setLimitPlaysToOne(e.target.checked)
                                      }
                                    />
                                    <label htmlFor='limitPlaysToOne'>
                                      {t('calCounterAndNewsletter.limitPlaysToOne')}
                                    </label>
                                  </div>
                                </ControlLabel>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('counterAndNewsletter.limitPlaysToOneTip')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 0 0 5px',
                                    fontSize: '15px'
                                  }}
                                />
                              </FormGroup>
                            </>
                          }
                        </Col>
                      </Row>}

                      <Button bsStyle='info' pullRight fill type='submit'>
                        {t('calCounterAndNewsletter.updateCounter')}
                      </Button>
                      <div className='clearfix' />
                    </form>
                  </>
                }
              />
            </Col>
          )}

          {type === 'advent' && (
            <Col md={6}>
              <Card
                title={t('calCounterAndNewsletter.reminder')}
                content={
                  <form onSubmit={handleSubmitReminder}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>
                            <div className='checkbox'>
                              <input
                                type='checkbox'
                                id='displayReminder'
                                name='displayReminder'
                                checked={reminderDisplay}
                                onChange={e =>
                                  setReminderDisplay(e.target.checked)
                                }
                              />
                              <label htmlFor='displayReminder'>
                                {t('calCounterAndNewsletter.displayReminder')}
                              </label>
                            </div>
                          </ControlLabel>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('counterAndNewsletter.displayReminder')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 0 0 5px',
                              fontSize: '15px'
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div
                      style={{
                        display: reminderDisplay === true ? 'block' : 'none'
                      }}
                    >
                      <FormGroup>
                        <i
                          className='pe-7s-help1 text-success'
                          data-tip={t('counterAndNewsletter.text')}
                          style={{
                            position: 'relative',
                            top: '1px',
                            padding: '5px 5px 0 0',
                            fontSize: '15px'
                          }}
                        />
                        <ControlLabel>
                          {t('calCounterAndNewsletter.textOfReminder')}
                        </ControlLabel>
                        <ReactQuill
                          value={reminderText}
                          modules={modules}
                          id='reminder'
                          name='contentReminder'
                          onChange={handleChangeQuillReminder}
                        />
                      </FormGroup>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <i
                              className='pe-7s-help1 text-success'
                              data-tip={t('counterAndNewsletter.linkLabel')}
                              style={{
                                position: 'relative',
                                top: '1px',
                                padding: '5px 5px 0 0',
                                fontSize: '15px'
                              }}
                            />
                            <ControlLabel>
                              {t('calCounterAndNewsletter.reminderLinkLabel')}
                            </ControlLabel>
                            <FormControl
                              type='text'
                              name='linkLabelReminder'
                              value={reminderLinkLabel}
                              onChange={e => {
                                setReminderLinkLabel(e.target.value)
                              }}
                              id='linkLabelReminder'
                              placeholder='select'
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <i
                              className='pe-7s-help1 text-success'
                              data-tip={t('counterAndNewsletter.linkUrl')}
                              style={{
                                position: 'relative',
                                top: '1px',
                                padding: '5px 5px 0 0',
                                fontSize: '15px'
                              }}
                            />
                            <ControlLabel>
                              {t('calCounterAndNewsletter.reminderLinkUrl')}
                            </ControlLabel>
                            <FormControl
                              type='text'
                              name='linkUrlReminder'
                              value={reminderLinkUrl}
                              onChange={e => {
                                setReminderLinkUrl(e.target.value)
                              }}
                              id='linkUrlReminder'
                              placeholder={t(
                                'calCounterAndNewsletter.urlToTargetingReminderPage'
                              )}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>

                    <Button bsStyle='info' pullRight fill type='submit'>
                      {t('calCounterAndNewsletter.updateReminder')}
                    </Button>
                    <div className='clearfix' />
                  </form>
                }
              />
            </Col>
          )}

          <Col md={6}>
            <Card
              title={t('calCounterAndNewsletter.newsletter')}
              content={
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <ControlLabel>
                          <div className='checkbox'>
                            <input
                              type='checkbox'
                              id='newsletterDisplay'
                              name='display'
                              checked={newsletterDisplay}
                              onChange={e =>
                                setNewsletterDisplay(e.target.checked)
                              }
                            />
                            <label htmlFor='newsletterDisplay'>
                              {t('calCounterAndNewsletter.displayNewsLetter')}
                            </label>
                          </div>
                        </ControlLabel>
                        <i
                          className='pe-7s-help1 text-success'
                          data-tip={t('counterAndNewsletter.display')}
                          style={{
                            position: 'relative',
                            top: '1px',
                            padding: '5px 0 0 5px',
                            fontSize: '15px'
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div
                    style={{
                      display: newsletterDisplay === true ? 'block' : 'none'
                    }}
                  >
                    <FormGroup>
                      <i
                        className='pe-7s-help1 text-success'
                        data-tip={t('counterAndNewsletter.text')}
                        style={{
                          position: 'relative',
                          top: '1px',
                          padding: '5px 5px 0 0',
                          fontSize: '15px'
                        }}
                      />
                      <ControlLabel>
                        {t('calCounterAndNewsletter.textOfNewsletter')}
                      </ControlLabel>
                      {modules && (
                        <ReactQuill
                          value={newsletterText}
                          modules={modules}
                          id='newsletter'
                          name='content'
                          onChange={handleChangeQuillNewsletter}
                        />
                      )}
                    </FormGroup>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('counterAndNewsletter.linkLabel')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calCounterAndNewsletter.newsletterLinkLabel')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='linkLabel'
                            id='linkLabel'
                            value={newsletterLinkLabel}
                            onChange={e =>
                              setNewsletterLinkLabel(e.target.value)
                            }
                            placeholder={t(
                              'calCounterAndNewsletter.newsletterLinkLabel'
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('counterAndNewsletter.linkUrl')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calCounterAndNewsletter.newsletterLinkUrl')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='linkUrl'
                            value={newsletterLinkUrl}
                            onChange={e => setNewsletterLinkUrl(e.target.value)}
                            id='linkUrl'
                            placeholder={t(
                              'calCounterAndNewsletter.urlToTargetingPage'
                            )}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  <Button bsStyle='info' pullRight fill type='submit'>
                    {t('calCounterAndNewsletter.updateNewsletter')}
                  </Button>
                  <div className='clearfix' />
                </form>
              }
            />
          </Col>
          <Col md={6}>
            <Card
              title={t('calCounterAndNewsletter.sponsors')}
              content={
                <form onSubmit={handleSubmitSponsors}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <ControlLabel>
                          <div className='checkbox'>
                            <input
                              type='checkbox'
                              checked={sponsorDisplay}
                              id='sponsorDisplay'
                              onChange={e =>
                                setSponsorDisplay(e.target.checked)
                              }
                            />
                            <label htmlFor='sponsorDisplay'>
                              {t('calCounterAndNewsletter.displaySponsors')}
                            </label>
                          </div>
                        </ControlLabel>
                        <i
                          className='pe-7s-help1 text-success'
                          data-tip={t('counterAndNewsletter.display')}
                          style={{
                            position: 'relative',
                            top: '1px',
                            padding: '5px 0 0 5px',
                            fontSize: '15px'
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Tabs
                    defaultActiveKey="sponsor1"
                    className="mb-3"
                    style={{
                      display: sponsorDisplay === true ? 'block' : 'none'
                    }}
                    onSelect={(target) => {
                      if (!target) {
                        setSponsors({
                          ...sponsors, [Object.keys(sponsors).length]: { logo: '', text: '', linkLabel: '', linkUrl: '', default: false }
                        })
                      }
                    }}
                  >
                    {sponsors && Object.keys(sponsors).map((index) => {
                      const sponsor = sponsors[index]
                      return (
                        <Tab eventKey={`sponsor${+index + 1}`} style={{ paddingTop: 10 }} title={
                          <div style={{ color: '#555' }}>
                            <b>{`Sponsor ${+index + 1} `}</b>
                            <FontAwesomeIcon
                              icon={faTrash}
                              size='lg'
                              onClick={() => {
                                const indexes = [...Object.keys(sponsors)].filter(val => val !== index)
                                const newSponsors = {}
                                indexes.forEach((item, index) => newSponsors[`${index}`] = sponsors[`${item}`])
                                setSponsors(newSponsors)
                              }}
                            />
                          </div>}>
                          <div>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('calCounterAndNewsletter.logoOfSponsor')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calCounterAndNewsletter.logoOfSponsor')}
                              </ControlLabel>
                              <FileSelector
                                type='image'
                                url={sponsor?.logo || ''}
                                disableDragAndDropProvider={true}
                                activeCompany={activeCompany}
                                onSelect={(file) => setSponsors({ ...sponsors, [index]: { ...sponsors[index], logo: file.url, default: false } })}
                              />
                            </FormGroup>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('calCounterAndNewsletter.textOfSponsor')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calCounterAndNewsletter.textOfSponsor')}
                              </ControlLabel>
                              {modules && (
                                <ReactQuill
                                  value={sponsor?.text || ''}
                                  // defaultValue={sponsor?.text || ''}
                                  id='sponsor'
                                  modules={modules}
                                  onChange={(e) => { handleChangeQuillSponsor(e, index) }}
                                />
                              )}
                            </FormGroup>
                            <Row>
                              <Col md={6}>
                                <FormGroup>
                                  <i
                                    className='pe-7s-help1 text-success'
                                    data-tip={t('counterAndNewsletter.linkLabel')}
                                    style={{
                                      position: 'relative',
                                      top: '1px',
                                      padding: '5px 5px 0 0',
                                      fontSize: '15px'
                                    }}
                                  />
                                  <ControlLabel>
                                    {t('calCounterAndNewsletter.sponsorLinkLabel')}
                                  </ControlLabel>
                                  <FormControl
                                    type='text'
                                    name='sponsorLinkLabel'
                                    value={sponsors[index]?.linkLabel || ''}
                                    onChange={e => {
                                      setSponsors({ ...sponsors, [index]: { ...sponsors[index], linkLabel: e.target.value, default: false } })
                                    }}
                                    id='sponsorLinkLabel'
                                    placeholder='select'
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup>
                                  <i
                                    className='pe-7s-help1 text-success'
                                    data-tip={t('counterAndNewsletter.linkUrl')}
                                    style={{
                                      position: 'relative',
                                      top: '1px',
                                      padding: '5px 5px 0 0',
                                      fontSize: '15px'
                                    }}
                                  />
                                  <ControlLabel>
                                    {t('calCounterAndNewsletter.sponsorLinkUrl')}
                                  </ControlLabel>
                                  <FormControl
                                    type='text'
                                    name='sponsorLinkUrl'
                                    value={sponsors[index]?.linkUrl || ''}
                                    onChange={e => {
                                      setSponsors({ ...sponsors, [index]: { ...sponsors[index], linkUrl: e.target.value, default: false } })
                                    }}
                                    id='sponsorLinkUrl'
                                    placeholder={t(
                                      'calCounterAndNewsletter.urlToTargetingReminderPage'
                                    )}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </div>
                        </Tab>
                      )
                    })}
                    <Tab disabled={sponsors && Object.keys(sponsors).length >= 15} title={<FontAwesomeIcon
                      icon={faCirclePlus}
                      size='lg'
                      color='#555'
                    />} />
                  </Tabs>
                  <Button bsStyle='info' pullRight fill type='submit'>
                    {t('calCounterAndNewsletter.updateSponsors')}
                  </Button>
                  <div className='clearfix' />
                </form>
              }
            />
          </Col>
          {type === 'memory-game' && (
            <Col md={6}>
              <Card title={t('calCounterAndNewsletter.timer')} content={<div>
                <form onSubmit={handleSubmitTimer}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <ControlLabel>
                          <div className='checkbox'>
                            <input
                              type='checkbox'
                              id='showTimer'
                              name='display'
                              checked={showTimer}
                              onChange={e =>
                                setShowTimer(e.target.checked)
                              }
                            />
                            <label htmlFor='showTimer'>
                              {t('calCounterAndNewsletter.showTimer')}
                            </label>
                          </div>
                        </ControlLabel>
                        <i
                          className='pe-7s-help1 text-success'
                          data-tip={t('counterAndNewsletter.showTimerTip')}
                          style={{
                            position: 'relative',
                            top: '1px',
                            padding: '5px 0 0 5px',
                            fontSize: '15px'
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {showTimer && (
                    <>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <ControlLabel>
                              {t('calCounterAndNewsletter.compareBy.title')}
                            </ControlLabel>
                            <FormControl
                              componentClass='select'
                              name='compareBy'
                              placeholder='select'
                              value={compareBy}
                              onChange={e => setCompareBy(e.target.value)}
                              id='compareBy'
                            >
                              <option value='speed'>{t('calCounterAndNewsletter.compareBy.speed')}</option>
                              <option value='accuracy'>{t('calCounterAndNewsletter.compareBy.accuracy')}</option>
                            </FormControl>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <ControlLabel>
                              {t('calCounterAndNewsletter.timerDuration')}
                            </ControlLabel>
                            <FormControl
                              type='number'
                              name='timerDuration'
                              value={timerDuration}
                              onChange={e => e.target.value ? setTimerDuration(parseInt(e.target.value)) : setTimerDuration(0)}
                              id='timerDuration'
                              min="1"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <i
                              className='pe-7s-help1 text-success'
                              data-tip={t('counterAndNewsletter.timerText')}
                              style={{
                                position: 'relative',
                                top: '1px',
                                padding: '5px 5px 0 0',
                                fontSize: '15px'
                              }}
                            />
                            <ControlLabel>
                              {t('calCounterAndNewsletter.textOfTimer')}
                            </ControlLabel>
                            {modules && (
                              <ReactQuill
                                value={timerText}
                                modules={modules}
                                id='timer'
                                name='content'
                                onChange={handleChangeQuillTimer}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  )}
                  <Button bsStyle='info' pullRight fill type='submit'>
                    {t('calCounterAndNewsletter.updateTimer')}
                  </Button>
                  <div className='clearfix' />
                </form>
              </div>} />
            </Col>
          )}
          {['hide-and-seek', 'memory-game'].includes(type) && (
            <Col md={6}>
              <Card
                title={t('calCounterAndNewsletter.socialMedia')}
                content={
                  <div>
                    <form onSubmit={handleSubmitSocialMedia}>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <ControlLabel>
                              <div className='checkbox'>
                                <input
                                  type='checkbox'
                                  id='socialMediaDisplay'
                                  name='display'
                                  checked={socialMediaDisplay}
                                  onChange={e =>
                                    setSocialMediaDisplay(e.target.checked)
                                  }
                                />
                                <label htmlFor='socialMediaDisplay'>
                                  {t('calCounterAndNewsletter.socialMediaDisplay')}
                                </label>
                              </div>
                            </ControlLabel>
                            <i
                              className='pe-7s-help1 text-success'
                              data-tip={t('counterAndNewsletter.socialMediaDisplay')}
                              style={{
                                position: 'relative',
                                top: '1px',
                                padding: '5px 0 0 5px',
                                fontSize: '15px'
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {socialMediaDisplay && (
                        <>
                          <FormGroup>
                            <i
                              className='pe-7s-help1 text-success'
                              data-tip={t('counterAndNewsletter.socialMediaText')}
                              style={{
                                position: 'relative',
                                top: '1px',
                                padding: '5px 5px 0 0',
                                fontSize: '15px'
                              }}
                            />
                            <ControlLabel>
                              {t('calCounterAndNewsletter.socialMediaTitle')}
                            </ControlLabel>
                            <ReactQuill
                              value={socialMediaText}
                              modules={modules}
                              id='socialMedia'
                              name='content'
                              onChange={handleChangeQuillSocialMedia}
                            />
                          </FormGroup>

                          <FormGroup>
                            <div className='checkbox'>
                              <FormControl
                                type='checkbox'
                                id='useStockIcons'
                                name='useStockIcons'
                                checked={useStockIcons}
                                onChange={e =>
                                  setUseStockIcons(e.target.checked)
                                }
                              />
                              <label htmlFor='useStockIcons'>
                                {t('calSettings.useStockIcons')}
                              </label>
                            </div>
                            <div style={{
                              opacity: useStockIcons ? 1.0 : 0.5,
                              pointerEvents: useStockIcons ? 'all' : 'none'
                            }}>
                              <Row>
                                <Col md={6}>
                                  <i
                                    className='pe-7s-help1 text-success'
                                    data-tip={t('settings.iconColor')}
                                    style={{
                                      position: 'relative',
                                      top: '1px',
                                      padding: '5px 5px 0 0',
                                      fontSize: '15px'
                                    }}
                                  />
                                  <ControlLabel>
                                    {t('calSettings.iconColor')}
                                  </ControlLabel>
                                  <ChromePicker
                                    styles={{
                                      'default': {
                                        picker: {
                                          width: '150px',
                                          marginBottom: '20px'
                                        }
                                      }
                                    }}
                                    disableAlpha
                                    color={socialMediaSettings.color || "#808080"}
                                    onChangeComplete={(color) => setSocialMediaSettings({ ...socialMediaSettings, color: color.hex })}
                                  />
                                </Col>
                                <Col md={6}>
                                  <i
                                    className='pe-7s-help1 text-success'
                                    data-tip={t('settings.iconSize')}
                                    style={{
                                      position: 'relative',
                                      top: '1px',
                                      padding: '5px 5px 0 0',
                                      fontSize: '15px'
                                    }}
                                  />
                                  <ControlLabel>
                                    {t('calSettings.iconSize')}
                                  </ControlLabel>
                                  <Radio.Group
                                    value={socialMediaSettings.size}
                                    size="small"
                                    style={{ marginTop: 5, display: 'block' }}
                                    onChange={(e) => { setSocialMediaSettings({ ...socialMediaSettings, size: e.target.value }) }}>
                                    <Radio.Button value="2x">Small</Radio.Button>
                                    <Radio.Button value="3x">Large</Radio.Button>
                                  </Radio.Group>
                                </Col>
                                <Col md={6}>
                                  <i
                                    className='pe-7s-help1 text-success'
                                    data-tip={t('settings.iconSize')}
                                    style={{
                                      position: 'relative',
                                      top: '1px',
                                      padding: '5px 5px 0 0',
                                      fontSize: '15px'
                                    }}
                                  />
                                  <ControlLabel>
                                    {t('calSettings.iconShape')}
                                  </ControlLabel>
                                  <Radio.Group
                                    value={socialMediaSettings.isRound}
                                    size="small"
                                    style={{ marginTop: 5, display: 'block' }}
                                    onChange={(e) => { setSocialMediaSettings({ ...socialMediaSettings, isRound: e.target.value }) }}>
                                    <Radio.Button value={true}>Round</Radio.Button>
                                    <Radio.Button value={false}>Rectangle</Radio.Button>
                                  </Radio.Group>
                                </Col>
                              </Row>
                            </div>
                          </FormGroup>

                          {socialIconList.map(item => <Row key={item} style={{ display: 'flex', alignItems: 'center' }}>
                            <Col md={9} style={{ flex: 1 }}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t(`settings.${item}-info`)}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t(`calSettings.${item}`)}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name={`${item}-label`}
                                  id={`${item}-label`}
                                  value={socialMediaIcons[item].label}
                                  onChange={e => {
                                    setSocialMediaIcons({ ...socialMediaIcons, [item]: { ...socialMediaIcons[item], label: e.target.value } })
                                  }}
                                  placeholder={t(
                                    `calSettings.${item}`
                                  ) + ' Label'}
                                />
                                <FormControl
                                  type='text'
                                  name={`${item}-link`}
                                  id={`${item}-link`}
                                  value={socialMediaIcons[item].url}
                                  onChange={e => {
                                    setSocialMediaIcons({ ...socialMediaIcons, [item]: { ...socialMediaIcons[item], url: e.target.value } })
                                  }}
                                  placeholder={t(
                                    `calSettings.pleaseProvide${item.slice(0, 1).toUpperCase() + item.slice(1)}`
                                  )}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                              {
                                useStockIcons ?
                                  <div style={{ display: 'flex', marginTop: '10px' }}>
                                    <SocialMediaIcon icon={socialIconMapping[item]} color={socialMediaSettings.color} size={socialMediaSettings.size} isRound={socialMediaSettings.isRound} />
                                  </div>
                                  : <FileSelector
                                    type='image'
                                    legacy
                                    activeCompany={activeCompany}
                                    activeCalendar={activeCalendar}
                                    fileName={item}
                                    pathToUpload='header-social-icons/'
                                    dbPath='settings/grid'
                                    dbField={`social_header_icon_${item}`}
                                    fullWidth
                                    onSelect={(file) => {
                                      setSocialMediaIcons({ ...socialMediaIcons, [item]: { ...socialMediaIcons[item], icon: file.url } })
                                    }}
                                  />
                              }
                            </Col>
                          </Row>)}

                        </>
                      )}
                      <Button bsStyle='info' pullRight fill type='submit'>
                        {t('calCounterAndNewsletter.updateSocialMedia')}
                      </Button>
                      <div className='clearfix' />
                    </form>
                  </div>
                }
              />
            </Col>
          )}
        </Row>
      </Grid>
      <ReactTooltip place='top' type='dark' effect='solid' />
    </>
  )
}

export default translate('translations')(CalHeaderBottom)
